import React from "react";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { Trans } from "@coworker/locales";
import { getActiveTask } from "./QuestionsDetailPage.helper";
import { Question } from "../BackendApiRepository/QuestionResponse";
import { ModalContext } from "@coworker/apprestructured/src/layout/context/ModalContextProvider";
import { ModalType } from "@coworker/apprestructured/src/layout/context/modalType";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useGetTaskByIdAndType } from "@coworker/apprestructured/src/tasks/hooks/useGetTaskByIdAndType";

interface MfaqTaskButtonProps {
  question: Question;
  filters: any; //TODO: Find out if we have type for this
}

const MfaqTaskButtonComponent: React.FC<MfaqTaskButtonProps> = ({
  question,
  filters,
}) => {
  const navigate = useFixaNavigate();
  const { toggleModal } = React.useContext(ModalContext);
  const { hasOngoingTask, taskId } = getActiveTask(question, filters[1]);
  const { data: task, isLoading: isTaskLoading } = useGetTaskByIdAndType(
    taskId ?? "",
    TaskType.MFAQ_FOLLOW_UP
  );

  const hasExistingOngoingTask = hasOngoingTask && task;
  const taskString = hasExistingOngoingTask
    ? "showTaskString"
    : "createTaskString";

  const createMFAQTask = () => {
    navigate(`/task/new/mfaq_followup`, {
      state: { question: { ...question, question_current_filters: filters } },
    });
  };
  const showMFAQTask = () => {
    toggleModal({
      type: ModalType.TaskDetail,
      payload: { taskId: taskId, taskType: TaskType.MFAQ_FOLLOW_UP },
    });
  };
  return (
    <FixaButton
      data-testid="createMFAQTask"
      type="primary"
      text={<Trans>{taskString}</Trans>}
      onClick={hasExistingOngoingTask ? showMFAQTask : createMFAQTask}
      loading={isTaskLoading}
    />
  );
};

export default MfaqTaskButtonComponent;
